<template>
  <b-container fluid>
    <b-row>
      <b-col class>
        <form method="GET" class="form-inline mb-5" v-on:submit="checkCode">
          <label class="d-block w-100 text-left" for="corporate_code">Voucher Code *</label>
          <label
            v-if="$store.state.corporateCode"
          >Applied Code: {{$store.state.corporateCode}} ({{$store.state.corporateDiscount * 100}}% discount)</label>

          <div class="form-group mb-2">
            <input class="form-control" name="corporate_code" required v-model="corporate_code" />
            <button
              class="btn btn-primary btn-md ml-2 text-uppercase"
              v-on:click="checkCode($event)"
            >Apply</button>
          </div>
          <label class="corporate--error">{{ error }}</label>
        </form>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  props: ["modalId"],
  components: {},
  data() {
    return {
      corporate_code: "",
      error: "",
    };
  },
  methods: {
    checkCode: function (event) {
      if (event) event.preventDefault();

      this.$axios
        .get("corporate", { params: { code: this.corporate_code } })
        .then((res) => {
          this.error = "";
          if (this.error == "") {
            this.$store.commit("corporateCode", this.corporate_code);
            this.$store.commit("corporateDiscount", res.data.data.discount);
          }
        })
        .catch((res) => {
          if (res.response.data.type) {
            this.error = res.response.data.message;
          }
        });
    },
  },
  mounted() {},
};
</script>